<script lang="ts">
    import type Monster from "../../lib/monster";
    import { getPathFor } from "../Attributes/util";
    import type { Point } from "../Attributes/util";
    import { convertNormalizedPath, generateFillColor } from "./util";
    export let monster: Monster;
    export let dimensions: number;
    const normalizedRange = 10;

    const generatePath = (sideLength: number): Point[] => {
        const path: Point[] = convertNormalizedPath(
            [
                { x: 1, y: 1 },
                { x: 8.5, y: 1 },
                { x: 8.5, y: 5.5 },
                { x: 7, y: 8 },
                { x: 5, y: 9 },
                { x: 4.5, y: 9 },
                { x: 2.5, y: 8 },
                { x: 1, y: 5.5 },
            ],
            sideLength,
            4,
            6
        );

        return path;
    };
</script>

{#if dimensions}
    <path
        d={getPathFor(generatePath(dimensions))(
            { x: dimensions / 2, y: dimensions / 2 },
            normalizedRange
        )}
        stroke="black"
        fill={generateFillColor('defense', monster)}
    />
{/if}

<style>
</style>
